export default {
    input: {
        backgroundColor: '#f1f1f1',
        padding: 5,
        borderRadius: 4,
        border: '1px solid #ccc',
    }
};
  